export const defaultBuyIn = 20;